import Marquee from "react-fast-marquee";

const ITEMS = [
    "Orçamento", "Renda Fixa", "Dividendos", "Fundos Imobiliários",
    "Reserva de Emergência", "Juros Compostos", "Independência Financeira", "Imposto de Renda",
];

export const EditorialMarquee = () => (
    <div data-testid="editorial-marquee" className="border-y border-white/10 bg-paper py-6 md:py-8 overflow-hidden">
        <Marquee speed={35} gradient={false} pauseOnHover>
            {ITEMS.map((item, i) => (
                <span key={i} className="flex items-center">
                    <span className="marquee-item text-2xl md:text-4xl text-slate-600 hover:text-gold transition-colors px-8 md:px-14 whitespace-nowrap">
                        {item}
                    </span>
                    <span className="w-1.5 h-1.5 rotate-45 bg-gold/60" />
                </span>
            ))}
        </Marquee>
    </div>
);
